'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useProps, ColorSwatch } from '@mantine/core';
import { useRichTextEditorContext } from '../RichTextEditor.context.mjs';
import { RichTextEditorControl } from './RichTextEditorControl.mjs';

const defaultProps = {};
const RichTextEditorColorControl = forwardRef((props, ref) => {
  const { color, ...others } = useProps("RichTextEditorColorControl", defaultProps, props);
  const { editor, labels, variant } = useRichTextEditorContext();
  const currentColor = editor?.getAttributes("textStyle").color || null;
  const label = labels.colorControlLabel(color);
  return /* @__PURE__ */ jsx(
    RichTextEditorControl,
    {
      ...others,
      variant,
      active: currentColor === color,
      "aria-label": label,
      title: label,
      onClick: () => (editor?.chain()).focus().setColor(color).run(),
      ref,
      children: /* @__PURE__ */ jsx(ColorSwatch, { color, size: 14 })
    }
  );
});
RichTextEditorColorControl.displayName = "@mantine/tiptap/RichTextEditorColorControl";

export { RichTextEditorColorControl };
//# sourceMappingURL=RichTextEditorColorControl.mjs.map
